<ngb-toast [ngClass]="{'text-white': toast.class !== 'warning' && toast.class !== 'info'}" [class]="'bg-' + toast.class" *ngFor="let toast of toasts" [autohide]="true" [delay]="toast.delay || 5000" (hidden)="removeToast.emit(toast)">
  <div [routerLink]="['errors']" class="d-flex flex-column" style="cursor: pointer">
    <div class="d-flex">
      <i *ngIf="!!toast.icon" class="fa fa-2x me-3 my-auto" [class]="toast.icon"></i>
      <div class="d-flex flex-column">
        <span class="fs-4">{{toast.title}}</span>
        <p>{{toast.message}}</p>
      </div>
    </div>
  </div>
</ngb-toast>
